import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Form } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import te from 'date-fns/locale/te';

registerLocale('te', te);

const DatePickerTab = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const highlightSundays = (date) => {
    return date.getDay() === 0 ? 'sunday' : '';
  };

  return (
    <Form.Group controlId="formBasicDate">
      <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        locale="te"
        dateFormat="dd MMMM yyyy"
        dayClassName={highlightSundays}
        inline // This prop makes the date picker inline
      />
    </Form.Group>
  );
};

export default DatePickerTab;
